import { render, staticRenderFns } from "./Rds.vue?vue&type=template&id=c3b5e93a&"
import script from "./Rds.vue?vue&type=script&lang=js&"
export * from "./Rds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports